export default __webpack_public_path__ + "static/media/jen-banner.5cdea59c.png";